module.exports = __webpack_public_path__ + "img/hair_back_female_wavy_medium.bdea2e8e.png";